module.exports = __webpack_public_path__ + "img/1450119275.eb3d4dfd.jpg";